import {Link as JoyLink, ListItemButton} from "@mui/joy"
import {createLink} from "@tanstack/react-router";

export const RouterJoyLink = createLink(JoyLink);
export const RouterListButton = createLink(ListItemButton);